import React from "react";
import {
  FaCheckCircle,
  FaLightbulb,
  FaHandshake,
  FaArrowUp,
  FaSmile,
} from "react-icons/fa"; // Example icons

const Testimonial = () => {
  return (
    <div className="bg-[#082028] py-12">
      {" "}
      {/* Updated background color */}
      {/* Title Section */}
      <div className="text-center p-3 mb-12">
        <h1 className="text-2xl text-[#D0B070] md:text-5xl font-bold mb-4 drop-shadow-lg">
          {" "}
          {/* Updated title color */}
          Nos Atouts
        </h1>
        <p className="text-gray-200 md:mb-12 text-[15px] md:text-lg leading-relaxed max-w-2xl mx-auto drop-shadow-sm">
          Découvrez nos points forts : un engagement sans faille, une
          transparence totale, des solutions toujours à jour et sur mesure pour
          garantir votre satisfaction.
        </p>
      </div>
      <div className="mx-auto flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12 py-8">
        {/* Card - Fiabilité */}
        <div className="w-[200px] md:w-[350px] bg-[#FFD700] text-gray-900 rounded-lg flex flex-col items-center justify-center p-4 shadow-lg">
          <FaCheckCircle className="text-3xl mb-2" />
          <h2 className="font-bold text-xl">Fiabilité</h2>
          <p className="text-gray-700 text-sm text-center">
            Nous respectons toujours nos engagements.
          </p>
        </div>

        {/* Card - Créativité */}
        <div className="w-[200px] md:w-[350px] bg-[#A89058] text-gray-900 rounded-lg flex flex-col items-center justify-center p-4 shadow-lg">
          <FaLightbulb className="text-3xl mb-2" />
          <h2 className="font-bold text-xl">Créativité</h2>
          <p className="text-gray-100 text-sm text-center">
            Des services sur mesure, innovants et originaux.
          </p>
        </div>

        {/* Card - Transparence */}
        <div className="w-[200px] md:w-[350px] bg-[#D0B070] text-gray-900 rounded-lg flex flex-col items-center justify-center p-4 shadow-lg">
          <FaHandshake className="text-3xl mb-2" />
          <h2 className="font-bold text-xl">Transparence</h2>
          <p className="text-gray-100 text-sm text-center">
            Communication claire et honnête à chaque étape.
          </p>
        </div>

        {/* Card - Évolution */}
        <div className="w-[200px] md:w-[350px] bg-[#505050] text-gray-900 rounded-lg flex flex-col items-center justify-center p-4 shadow-lg">
          <FaArrowUp className="text-3xl mb-2" />
          <h2 className="font-bold text-xl">Évolution</h2>
          <p className="text-gray-100 text-sm text-center">
            Des solutions toujours à jour avec les dernières innovations.
          </p>
        </div>

        {/* Card - Satisfaction Clients */}
        <div className="w-[200px] md:w-[350px] md:h-[135px] bg-[#A89058] text-gray-900 rounded-lg flex flex-col items-center justify-center p-4 shadow-lg">
          <FaSmile className="text-3xl mb-2" />
          <h2 className="font-bold text-xl">Satisfaction Clients</h2>
          <p className="text-gray-100 text-sm text-center">
            Votre satisfaction est notre priorité.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
